import KendoArcGauge from '../KendoArcGauge'
import KendoLinearGauge from '../KendoLinearGauge'
import KendoRadialGauge from '../KendoRadialGauge'
import KendoArcGaugeColor from '../KendoArcGauge/KendoArcGaugeColor'
import KendoLinearGaugePointer from '../KendoLinearGauge/KendoLinearGaugePointer'
import KendoRadialGaugePointer from '../KendoRadialGauge/KendoRadialGaugePointer'

let KendoGaugesInstaller = class {
    static install(Vue) {
        Vue.component(KendoArcGauge.name, KendoArcGauge)
        Vue.component(KendoArcGaugeColor.name, KendoArcGaugeColor)
        Vue.component(KendoLinearGauge.name, KendoLinearGauge)
        Vue.component(KendoLinearGaugePointer.name, KendoLinearGaugePointer)
        Vue.component(KendoRadialGauge.name, KendoRadialGauge)
        Vue.component(KendoRadialGaugePointer.name, KendoRadialGaugePointer)
    }
}

export default KendoGaugesInstaller

// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoGaugesInstaller)
}


// WEBPACK FOOTER //
// ./packages/kendo-gauges-vue-wrapper/src/kendo-gauges-installer/index.js